'use client';

import { getSnapshot, type Instance, t } from 'mobx-state-tree';

/** InstancedGeometryToolSettings Model */
export const InstancedGeometryToolSettings = t
  .model('InstancedGeometryToolSettings', {
    brushRadius: t.optional(t.number, 5),
    eraserRadius: t.optional(t.number, 20),
    density: t.optional(t.number, 20),
    updateHz: t.optional(t.number, 30),
    mode: t.optional(t.enumeration(['none', 'brush', 'eraser']), 'none'),
    multiScatter: t.optional(t.boolean, true), // Randomly scatter across all components in actor
    snapToNormal: t.optional(t.boolean, true), // Align instances to surface normal
  })
  .views(self => ({
    get values() { return getSnapshot(self); }
  }))
  .actions(self => ({
    update(values: Partial<typeof self>) {
      Object.entries(values).forEach(([key, value]) => {
        if (key in self && value !== undefined) {
          (self as any)[key] = value;
        }
      });
    },
    setBrushRadius(radius: number) {
      self.brushRadius = Math.max(0.1, radius); // Ensure minimum radius
    },
    setEraserRadius(radius: number) {
      self.eraserRadius = Math.max(0.1, radius); // Ensure minimum radius
    },
    setDensity(density: number) {
      self.density = Math.max(0.1, density); // Ensure minimum density
    },
    setUpdateHz(updateHz: number) {
      self.updateHz = Math.min(120, Math.max(1, updateHz));
    },
    setMode(mode: 'none' | 'brush' | 'eraser') {
      self.mode = mode;
    },
    setMultiScatter(multiScatter: boolean) {
      self.multiScatter = multiScatter;
    },
    setSnapToNormal(snapToNormal: boolean) {
      self.snapToNormal = snapToNormal;
    },
  }));

export interface IInstancedGeometryToolSettings extends Instance<typeof InstancedGeometryToolSettings> { }

